import './staff.css'
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/system';
import StaffStudy from '../../pages/StaffStudy/staffStudy.js'
import axios from 'axios';
import { useLocation } from 'react-router-dom'
import { Typography } from '@mui/material';
import StaffFileUploadComponent from '../StaffStudyDocument/StaffStudyDocument.js';



const StyledTab = styled(Tab)({
    fontSize: '1.1rem',
    fontWeight: '600', // Increased label size
    color: '#008B8B', // Default color
    '&:hover': {
        color: '#169a8f', // Change color to yellow on hover
    },
    '&.Mui-selected': {
        color: '#169a8f', // Change color to blue for the active tab
    },
    paddingLeft: '10px',
    marginRight: '50px', // Add spacing between tabs
    fontFamily:'nunito'

});

const StyledTabList = styled(TabList)({
    background: '#E0F2F1', /* Fallback for old browsers */
    background: '-webkit-linear-gradient(to left, #B2DFDB, #E0F2F1)', /* Chrome 10-25, Safari 5.1-6 */
    background: 'linear-gradient(to left, #B2DFDB, #E0F2F1)', /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    backgroundColor: '#ffffff', // Background color
    color: '#169a8f',
    display: 'flex', // Flexbox display
    justifyContent: 'around', // Centering tabs
    alignItems: 'center' // Aligning items vertically
});


const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

function StaffProfile({ setShowSpinner }) {
    const [value, setValue] = React.useState('1');
    const [staffData, setStaffData] = useState({})
    const [pdfUrls, setPdfUrls] = useState([]);
    const [getData, setGetData] = useState(true);

    let query = useQuery();
    let paramValue = query.get("staffId");
    // Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const fetchData = async () => {
        setShowSpinner(true);
        try {
            // Example: Fetching PDF URLs with Axios and headers
            const response = await axios.get(`https://research-mate-b35a10757d5a.herokuapp.com/api/staff/oneStaff?staffId=${paramValue}`, {
                headers: {
                    'Authorization': `Bearer ${tokenValue}`,
                    'Content-Type': 'application/json'
                    // Add other headers as needed
                }
            });
            setStaffData(response.data.staff)
            const data = response.data.staff.documents;
            setPdfUrls(data);
        } catch (error) {
            console.error('Error fetching PDF URLs:', error);
        }
        setShowSpinner(false);
    };

    useEffect(() => {
        fetchData();
    }, [getData]);



    const handleDocumentClick = (url) => {
        window.open(url, '_blank');
    };

    return (
        <div className='p-2'>
            <h4 style={{color:'rgb(23 131 131)'}}>Organization Staff ({staffData.name})</h4>
            <div className='mt-3'>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <StyledTabList onChange={handleChange} aria-label="lab API tabs example">
                                <StyledTab label="Documents" value="1" />
                                <StyledTab label="Study Exp" value="2" />
                            </StyledTabList>
                        </Box>
                        <TabPanel value="1">
                            <div style={{width:'50%'}} className='row d-flex align-items-center'>
                                {
                                    (staffData.documents ? staffData.documents.length : 0) === 3 ?
                                        pdfUrls.map((doc, index) => {
                                            return (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        mt: 2,
                                                        p: 2,
                                                        borderRadius: '4px',
                                                        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 20px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => handleDocumentClick(doc)}
                                                >
                                                    <h5>{`${staffData.name.toUpperCase()} DOCUMENTS`}</h5>
                                                        <h5>
                                                    {doc ? doc.split("/")[doc.split("/").length - 2].toUpperCase() : ""}
                                                        </h5>
                                                </Box>
                                            )
                                        }) :
                                        <StaffFileUploadComponent
                                            getData={getData}
                                            setGetData={setGetData}
                                            urls={pdfUrls}
                                            _id={staffData._id}
                                            setShowSpinner={setShowSpinner}
                                        />
                                }
                            </div>
                        </TabPanel>
                        <TabPanel value="2">
                            <StaffStudy />
                        </TabPanel>
                    </TabContext>
                </Box>
            </div>
        </div>
    );
}

export default StaffProfile;
